import React from 'react'
import { Field } from 'formik'
import FieldColumn from '../field-column'
import MultiSelectField from '../../form/fields/multi-select'
import { PayrollWeekStatus } from '../../../store/filters'

interface WeekStatusFilterFieldProps {
  name: string
  label?: string
}

/**
 * Options pour le multiselect des statuts de clôture des semaines
 */
const WEEK_STATUS_OPTIONS: { value: PayrollWeekStatus; label: string }[] = [
  {
    value: 'closed',
    label: 'Clôturées',
  },
  {
    value: 'readyToClose',
    label: 'À clôturer',
  },
  {
    value: 'needsValidation',
    label: 'Validation requise',
  },
]

/**
 * Composant de filtre multiselect pour les statuts de clôture des semaines de paie
 * Permet de filtrer les workers selon le statut de leurs semaines :
 * - Clôturées : toutes les semaines sont enregistrées
 * - À clôturer : toutes les semaines sont validées mais pas encore enregistrées
 * - Validation requise : certaines semaines ne sont pas validées
 */
const WeekStatusFilterField: React.FC<WeekStatusFilterFieldProps> = ({
  name,
  label = 'Statut des semaines',
}) => {
  return (
    <FieldColumn>
      <Field
        label={label}
        name={name}
        component={MultiSelectField}
        options={WEEK_STATUS_OPTIONS}
        placeholder="Choisir les statuts..."
      />
    </FieldColumn>
  )
}

export default WeekStatusFilterField
